import { Injectable } from "@angular/core";
import { CollectionView } from "@grapecity/wijmo";
@Injectable({
    providedIn: "root"
})
export class CommonZipInsUtils {
    constructor() {}
    setSelectZips(refilFG, zipCodes, selectedRecrds: any[],StName) {
        const selectedZipCodes = new Set(refilFG.value["zipCodesArray"] || []);
        const wijmoZip: any[] = [];
        const unmatchedZip: string[] = [];
        zipCodes.forEach((item: any) => {
            if (selectedZipCodes.has(item["ZipCode"])) {
                wijmoZip.push(item);
            }
        });
        refilFG.value["zipCodesArray"]?.forEach((zip: string) => {
            if (!zipCodes.some((item: any) => item["ZipCode"] === zip)) {
                unmatchedZip.push(zip);  // for zips which are added directly in the text area
            }
        });
        const selectedList = this.generateZipWJ(wijmoZip,unmatchedZip, selectedRecrds, StName);
        return selectedList;
    }
    generateZipWJ(wijmoZipList, unmatchedZipCodes, selectedRecrds,StName) {
      let mapDataSet = [];
      wijmoZipList.map((zipInf, i)=> {
          const j = {};
          j["RowId"] = i;
          j["Zip Code"] = zipInf.ZipCode;
          j["State"] = StName;
          j["City"] = zipInf.CityName;
          j["Id"] = zipInf.Id;
          j["IsSelected"] = true;
          mapDataSet.push(j)
        });
        let selectedZIPWJ = new CollectionView(mapDataSet);
        selectedRecrds = selectedRecrds || [];
        if (selectedZIPWJ?.items?.length) {
          selectedRecrds.push(...selectedZIPWJ.items);
        }
        // 2. Add unmatched zip codes as new entries
        if (unmatchedZipCodes?.length) {
          unmatchedZipCodes.forEach((zip: any, index: number) => {
            selectedRecrds.push({
              RowId: selectedRecrds.length,
              "Zip Code": zip,
              State: null,
              City: null,
              IsSelected: true,
            });
          });
        }
        return selectedRecrds;
    }

    selctedExcldInsurance(refillFG, insuranceData) {
        const selctedExcldIns = refillFG.value["ExcludeInsuranceType"] || [];
        const wijmoList: any[] = [];
        insuranceData.forEach((item: any) => {
            if (selctedExcldIns.includes(item["PlanCode"])) {
                wijmoList.push(item);
            }
        });
        return this.generateInsuWJ(wijmoList);
    }
    generateInsuWJ(wijmoList) {
        let selectedInsuCodes = [];
        let mapDataSet = [];
        wijmoList.map((ins)=> {
            const j = {};
            j["Ins.Code"] = ins["PlanCode"];
            j["Ins.Name"] = ins["InsuranceName"];
            j["Bin#"] = j["BIN"] = ins.BinNum;
            j["Processor Ctrl#"] = ins.ProcessorNum;
            j["Pharmacy Id"] = ins.PharmacyNum;
            j["Address"] = ins.Address;
            j["Phone No"] = j["Phone#"] = ins.PhoneNumber;
            j["RowId"] = ins["PlanCode"] + ins["Id"];
            j["Id"] = ins["Id"];
            j["IsSelected"] = true;
            mapDataSet.push(j)
          })
        const selectedInsWJ = new CollectionView(mapDataSet);
        selectedInsuCodes = selectedInsuCodes || [];
        selectedInsWJ?.items.forEach((finalItem: any) => {
        selectedInsuCodes.push(finalItem);
        });
        return selectedInsuCodes;
    }

    updateZipCodeList(event, optedZipList) {
        if (event?.type === "Remove") {
            const removdZipIndex = optedZipList.findIndex((item: any) => item["Zip Code"] === event?.value);
            optedZipList.splice(removdZipIndex, 1);
        } else if (event?.type === "Add") {
            const newObj = {"RowId": optedZipList?.length ? optedZipList.length : 0, "Zip Code": event?.value, "State": null,"City": null, "IsSelected": true};
            optedZipList.push(newObj);
        }
        let zipsInfo = "";
        let zipsListInf = [];
        if (optedZipList && optedZipList.length) {
            optedZipList.forEach((List, i) => {
                zipsInfo += zipsInfo === "" ? List["Zip Code"] : "," + List["Zip Code"];
            });
            zipsInfo = zipsInfo.split(",").filter((elem, index, self) => {
                return index === self.indexOf(elem);
            }).join();
            zipsListInf = zipsInfo.split(",");
        }
        return {zipsList: zipsListInf, zips: zipsInfo, optedZipList: optedZipList}
    }
    updateInsuranceList(event, selectInsuList) {
        const removdInsIndex = selectInsuList.findIndex((item: any) => item["Ins.Code"] === event.value);
        selectInsuList.splice(removdInsIndex, 1);
        const inscodeList = selectInsuList.map((insItem: any) => insItem["Ins.Code"]);
        const insIdList = selectInsuList.map((insItem: any) => insItem["Id"]);
        return {inscodeList: inscodeList,insIdList: insIdList,selectedInsCodes: selectInsuList}
    }
}